"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FALLBACK_TREE_PROJECT_ID = exports.activeEdenTreeProjects = exports.activeTreeProjects = void 0;
const calculate_tree_project_probability_1 = require("../utils/calculate-tree-project-probability");
// These are our main (internal) tree projects — please do not export them standalone.
// The numbers correspond with each project's Wordpress id.
const ARGENTINA = 5263;
const BOLIVIA = 5273;
const ECUADOR = 5279;
const ETHIOPIA_GEWOCHA = 6244;
const KENYA_DUNDORI = 5369;
const KENYA_KAKAMEGA = 6302;
const KENYA_MAU = 3503;
const MADAGASCAR_KANDRANY = 6299;
const MOROCCO_OUEZZANE = 5385;
const MOZAMBIQUE_IRREGELE = 6301;
const MOZAMBIQUE_MUSSUQUELANE = 6300;
const PERU = 5290;
const SENEGAL_TAMBACOUNDA = 5980;
const TANZANIA_IRINGA = 5644;
const UGANDA_MBALE = 3546;
// Tree projects currently live in the system
exports.activeTreeProjects = (0, calculate_tree_project_probability_1.calculateTreeProjectProbability)([
    [ARGENTINA, 0.309],
    [BOLIVIA, 0.309],
    [ECUADOR, 0.309],
    [ETHIOPIA_GEWOCHA, 16.495],
    [KENYA_DUNDORI, 0.734],
    [KENYA_KAKAMEGA, 1.415],
    [KENYA_MAU, 20.615],
    [MADAGASCAR_KANDRANY, 24.757],
    [MOROCCO_OUEZZANE, 1.441],
    [MOZAMBIQUE_IRREGELE, 11.229],
    [MOZAMBIQUE_MUSSUQUELANE, 5.643],
    [PERU, 0.309],
    [SENEGAL_TAMBACOUNDA, 2.652],
    [TANZANIA_IRINGA, 9.775],
    [UGANDA_MBALE, 4.008],
]);
// Eden-price matched tree projects currently live in the system
exports.activeEdenTreeProjects = (0, calculate_tree_project_probability_1.calculateTreeProjectProbability)([
    [MADAGASCAR_KANDRANY, 47.214],
    [MOZAMBIQUE_IRREGELE, 14.546],
    [MOZAMBIQUE_MUSSUQUELANE, 7.273],
    [KENYA_MAU, 30.967],
]);
// Used as a fallback in situations where we need a default tree project id (should be
// used as a last resort)
exports.FALLBACK_TREE_PROJECT_ID = MADAGASCAR_KANDRANY;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJlZS1wcm9qZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90cmVlLXByb2plY3RzL3RyZWUtcHJvamVjdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsb0dBQThGO0FBRTlGLHNGQUFzRjtBQUN0RiwyREFBMkQ7QUFFM0QsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFDO0FBQ3ZCLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQztBQUNyQixNQUFNLE9BQU8sR0FBRyxJQUFJLENBQUM7QUFDckIsTUFBTSxnQkFBZ0IsR0FBRyxJQUFJLENBQUM7QUFDOUIsTUFBTSxhQUFhLEdBQUcsSUFBSSxDQUFDO0FBQzNCLE1BQU0sY0FBYyxHQUFHLElBQUksQ0FBQztBQUM1QixNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUM7QUFDdkIsTUFBTSxtQkFBbUIsR0FBRyxJQUFJLENBQUM7QUFDakMsTUFBTSxnQkFBZ0IsR0FBRyxJQUFJLENBQUM7QUFDOUIsTUFBTSxtQkFBbUIsR0FBRyxJQUFJLENBQUM7QUFDakMsTUFBTSx1QkFBdUIsR0FBRyxJQUFJLENBQUM7QUFDckMsTUFBTSxJQUFJLEdBQUcsSUFBSSxDQUFDO0FBQ2xCLE1BQU0sbUJBQW1CLEdBQUcsSUFBSSxDQUFDO0FBQ2pDLE1BQU0sZUFBZSxHQUFHLElBQUksQ0FBQztBQUM3QixNQUFNLFlBQVksR0FBRyxJQUFJLENBQUM7QUFFMUIsNkNBQTZDO0FBQ2hDLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxvRUFBK0IsRUFBQztJQUNoRSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUM7SUFDbEIsQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDO0lBQ2hCLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQztJQUNoQixDQUFDLGdCQUFnQixFQUFFLE1BQU0sQ0FBQztJQUMxQixDQUFDLGFBQWEsRUFBRSxLQUFLLENBQUM7SUFDdEIsQ0FBQyxjQUFjLEVBQUUsS0FBSyxDQUFDO0lBQ3ZCLENBQUMsU0FBUyxFQUFFLE1BQU0sQ0FBQztJQUNuQixDQUFDLG1CQUFtQixFQUFFLE1BQU0sQ0FBQztJQUM3QixDQUFDLGdCQUFnQixFQUFFLEtBQUssQ0FBQztJQUN6QixDQUFDLG1CQUFtQixFQUFFLE1BQU0sQ0FBQztJQUM3QixDQUFDLHVCQUF1QixFQUFFLEtBQUssQ0FBQztJQUNoQyxDQUFDLElBQUksRUFBRSxLQUFLLENBQUM7SUFDYixDQUFDLG1CQUFtQixFQUFFLEtBQUssQ0FBQztJQUM1QixDQUFDLGVBQWUsRUFBRSxLQUFLLENBQUM7SUFDeEIsQ0FBQyxZQUFZLEVBQUUsS0FBSyxDQUFDO0NBQ3RCLENBQUMsQ0FBQztBQUVILGdFQUFnRTtBQUNuRCxRQUFBLHNCQUFzQixHQUFHLElBQUEsb0VBQStCLEVBQUM7SUFDcEUsQ0FBQyxtQkFBbUIsRUFBRSxNQUFNLENBQUM7SUFDN0IsQ0FBQyxtQkFBbUIsRUFBRSxNQUFNLENBQUM7SUFDN0IsQ0FBQyx1QkFBdUIsRUFBRSxLQUFLLENBQUM7SUFDaEMsQ0FBQyxTQUFTLEVBQUUsTUFBTSxDQUFDO0NBQ3BCLENBQUMsQ0FBQztBQUVILHNGQUFzRjtBQUN0Rix5QkFBeUI7QUFDWixRQUFBLHdCQUF3QixHQUFHLG1CQUFtQixDQUFDIn0=